import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../context/AppContext";
import useHttp from "../hooks/useHttp";
import ConversationView from "./ConversationPage";
import { initPusher } from "./utils/CommonVessels";
import { checkIsLicensedByLicenseStatus } from "./utils/commonUtils";
import { usePusher } from "../context/PusherContext";
import { Navigate, useParams } from "react-router-dom";

export const ConvContext = React.createContext();

export const DEFAULT_CONTACT_ID = "new_contact";

const ConvProvider = ({ children, setLoaded, chatView }) => {
  const [appProperties] = useContext(AppContext);
  const [conversationContext, setConversationContext] = useState(false);
  const { channelRefOrg, connect, unSubscribe } = usePusher();
  const selectedContactId = useRef(DEFAULT_CONTACT_ID);
  const { fetchData } = useHttp();

  useEffect(() => {
    if (
      appProperties?.osyncId &&
      checkIsLicensedByLicenseStatus(appProperties?.licenseObj?.licenseDetails?.licenseStatus ?? Number.MAX_SAFE_INTEGER)
    ) {
      connect(false, true).then((_) => setLoaded(true));
    }
    return () => {
      unSubscribe("CONTACTS_UPDATE", "ConvProvider::28");
      unSubscribe("CONVERSATION_UPDATE", "ConvProvider::29");
      unSubscribe("CONTACT_INFO_UPDATE", "ConversationView::CONTACT_INFO_UPDATE");
    };
  }, [appProperties?.osyncId]);

  const sendsms = (integId, body) => {
    return new Promise((resolve, reject) => {
      const header = !chatView ? { "restrict-access": "true" } : undefined;
      fetchData(`omessage/${integId}/send`, "POST", body, appProperties, header)
        .then(function (response) {
          try {
            if (response) {
              resolve(response);
            } else {
              reject(new Error("Empty response"));
            }
          } catch (error) {
            console.error("Error processing response:", error);
            reject(error);
          }
        })
        .catch((error) => {
        reject(error);
      });
    });
  };

  return (
    <ConvContext.Provider
      value={{
        channel: channelRefOrg,
        selectedContactId,
        conversationContext,
        setConversationContext,
        sendsms,
      }}
    >
      {children}
    </ConvContext.Provider>
  );
};

const ConversationWrapper = (props) => {
  const {
    chatView,
    toNumber,
    setHelloSend,
    fromSendSMSPage,
    phoneFieldConfiguration,
    setPhoneFieldConfiguration,
    setToNumberNumberInFormView,
    onConversationsLoaded,
  } = props;
  const [loaded, setLoaded] = useState(false);
  return (
    <ConvProvider setLoaded={setLoaded} chatView={chatView}>
      {loaded && (
        <ConversationView
          chatView={chatView}
          toNumber={toNumber}
          setHelloSend={setHelloSend}
          fromSendSMSPage={fromSendSMSPage}
          phoneFieldConfiguration={phoneFieldConfiguration}
          setPhoneFieldConfiguration={setPhoneFieldConfiguration}
          setToNumberNumberInFormView={setToNumberNumberInFormView}
          onConversationsLoaded={onConversationsLoaded}
        />
      )}
    </ConvProvider>
  );
};

export default ConversationWrapper;
